import React from 'react';
import { SwitchableFeature } from '../features/SwitchableFeature/SwitchableFeature';
import { CART } from '../features/SwitchableFeature/SwitchableFeature.definitions';
import usePaymentModalHandler from './usePaymentModalHandler';
import { loadClientComponent } from '../utils/loadClientComponent';

//Load following components on client side. This excludes them from SSR generated chunks
const ExpiredSessionModal = loadClientComponent(() => import('../components/ExpiredSessionModal'));
const PaymentStatusPopup = loadClientComponent(() => import('../components/PaymentStatusPopup/PaymentStatusPopup'));
const NotificationPopup = loadClientComponent(() => import('../components/NotificationPopup'));
const LogoutModal = loadClientComponent(() => import('../components/LogoutModal'));
const CartBootstrap = loadClientComponent(() => import('../components/CartBootstrap/CartBootstrap'));

const OffScreen = () => {
  const {
    paymentStatusPopupShown,
    closePaymentStatusPopup,
    processedOrderId,
    paymentSuccess,
  } = usePaymentModalHandler();

  return (
    <>
      {/* todo: request those components on demand, exclude from bandle when feature is disabled */}
      <NotificationPopup />
      <ExpiredSessionModal isOpen={false} />
      <SwitchableFeature feature={CART}>
        <CartBootstrap />
      </SwitchableFeature>
      {paymentStatusPopupShown && (
        <PaymentStatusPopup onClose={closePaymentStatusPopup} success={paymentSuccess} orderId={processedOrderId} />
      )}
      <LogoutModal />
    </>
  );
};

export default OffScreen;
